import { render, staticRenderFns } from "./CardsStyle.vue?vue&type=template&id=117d82bc&"
import script from "./CardsStyle.vue?vue&type=script&lang=js&"
export * from "./CardsStyle.vue?vue&type=script&lang=js&"
import style0 from "./CardsStyle.vue?vue&type=style&index=0&id=117d82bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports